import { ApexApiError } from 'apex-ui-services'
import { restrictAccount as restrictAccountRemote } from '../api'
import { HttpResponseStatusCodes } from '../constants'
import { AccountStatus } from '../types'
import {
  ACCOUNT_RESTRICTION_FAILED,
  TEMPORARILY_UNAVAILABLE,
} from './constants'

export const restrictAccount = (
  onError: (error: string) => void,
  onSuccess: () => void,
  accountNumber: string,
  accountStatus: AccountStatus,
  reason: string
) => {
  restrictAccountRemote(accountNumber, accountStatus, reason)
    .then(onSuccess)
    .catch((error: ApexApiError) => {
      const httpResponseStatus = error.response?.status
      let errorMessage: string = ''

      switch (httpResponseStatus) {
        case HttpResponseStatusCodes.Forbidden:
          errorMessage = ACCOUNT_RESTRICTION_FAILED
          break
        case HttpResponseStatusCodes.InternalServerError:
        case HttpResponseStatusCodes.ServiceUnavailable:
          errorMessage = TEMPORARILY_UNAVAILABLE
          break
        default:
          break
      }
      errorMessage && onError(errorMessage)
    })
}
